import React from "react"
import AvatarBase from "@love-irish/core-avatar"
import { ResultRowShell } from "./result_row_shell"
import { initials } from "./initials"
import type { SearchRowComponent } from "./types"

// core-avatar is a JS/PropTypes component; cast to a loose FC as the rest of the app does.
const Avatar = AvatarBase as unknown as React.FC<Record<string, unknown>>

export const NpcBadge: React.FC<{ className?: string }> = ({ className }) => (
  <span
    title="System-managed account"
    data-testid="npc-badge"
    className={`inline-flex cursor-help items-center rounded border border-secondary-300 px-1 text-[10px] font-semibold uppercase text-muted-foreground ${
      className ?? ""
    }`}
  >
    NPC
  </span>
)

// A person result: their avatar (or initials fallback), display name, and "@handle". The avatar is the
// whole point of a profile row — it makes people scannable in a mixed result list.
export const ProfileRow: SearchRowComponent = ({ hit, position, onSelect }) => {
  console.log("Rendering ProfileRow for hit:", hit) // Debugging log
  return (
    <ResultRowShell
      hit={hit}
      position={position}
      onSelect={onSelect}
      className="pl-2"
    >
      <Avatar
        size="md"
        src={hit.avatar?.imageUrl ?? undefined}
        alt={hit.name}
        className="pixel-art shrink-0"
      >
        {initials(hit.name)}
      </Avatar>
      <div>
        <p className="truncate">
          {hit.name} {hit.type === "Profile::Npc" && <NpcBadge />}
        </p>
        {hit.username && (
          <p className="truncate text-xs text-secondary-400">{hit.username}</p>
        )}
      </div>
    </ResultRowShell>
  )
}
